module.exports = __webpack_public_path__ + "MinionPro-Regular.38711b5bb243e894a6d5.otf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/MinionPro-Regular.otf
// module id = ../../../../../src/assets/fonts/MinionPro-Regular/MinionPro-Regular.otf
// module chunks = styles